import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Component from './component'
import { loadCustomers } from '../../ducks/customers'

function mapStateToProps (state, ownProps) {
  return {
    ...ownProps,
    fetched: state.customers.fetched,
    fetching: state.customers.fetching,
    list: state.customers.list
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ loadCustomers }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./ui/customers/index.js